import { gql } from "@apollo/client";

export const COUNTRY_FRAGMENT = gql`
  fragment CountryFragment on Country {
    id
    isoCode
    name
    createdAt
    updatedAt
    plans {
      id
      name
      accessType
      priceInCents
      periodUnit
      platform
    }
  }
`;

export const GET_COUNTRIES = gql`
  query GetCountries(
    $filter: CountryFilter
    $pagination: ConnectionArgs
    $sort: OrderByInput
  ) {
    admin {
      countries(filter: $filter, pagination: $pagination, sort: $sort) {
        edges {
          node {
            ...CountryFragment
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
  ${COUNTRY_FRAGMENT}
`;

export const GET_COUNTRY = gql`
  query GetCountry($id: String!) {
    admin {
      countryById(id: $id) {
        ...CountryFragment
      }
    }
  }
  ${COUNTRY_FRAGMENT}
`;

export const CREATE_COUNTRY = gql`
  mutation CreateCountry($input: CreateCountryInput!) {
    adminCountryCreate(input: $input) {
      ...CountryFragment
    }
  }
  ${COUNTRY_FRAGMENT}
`;

export const UPDATE_COUNTRY = gql`
  mutation UpdateCountry($id: String!, $input: UpdateCountryInput!) {
    adminCountryUpdate(id: $id, input: $input) {
      ...CountryFragment
    }
  }
  ${COUNTRY_FRAGMENT}
`;
